import classNames from 'classnames';
import type { ElementType, FC, JSX, PropsWithChildren } from 'react';

import styles from './accent-text.module.css';

export type AccentTextProps = PropsWithChildren & {
  className?: string;
  renderAs?: ElementType | keyof JSX.IntrinsicElements;
};

export const AccentText: FC<AccentTextProps> = ({ children, className, renderAs: Tag = 'span', ...props }) => (
  <Tag {...props} className={classNames(className, styles['accent-text'])}>
    {children}
  </Tag>
);
